import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import Select from "react-select";
import CKeditorComponent from "../../common-component/CKeditorComponent";
import closeImage from "../../../assets/images/close-white.svg";
import blueaddicon from "../../../assets/images/blueaddicon.svg";
import My_machine from "../../../assets/images/My_machine.svg";
import download from "../../../assets/images/download.svg";
// import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useDispatch, useSelector } from "react-redux";
import { CaseSave } from "../../../services/ReduxTookit/Slice/CaseRedux";
import { commonservices } from "../../../services/CommonServices";
import { default as infoIcon } from "../../../assets/images/infobtnblue.svg";
import { ProjectTermGetList } from "../../../services/ReduxTookit/Slice/ProjectTermRedux";
import Loader, { LoaderType } from "../../common-component/Loader";
import SubmitLoading from "../../common-component/Loaders/SubmitLoading";

function InvoiceModel(props) {
  let machineid = "";
  const MachineLogoref = useRef();
  const dispatch = useDispatch();
  const [BannerImageState, setBannerImageState] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [ProjectTermList, setProjectTermList] = useState({
    Priority: [],
  });
  const [supportInput, setSupportInput] = useState({
    relatedTo: props?.relatedToLabel, // props?.case_Type,
    subject: "",
    seversity: "",
    tags: "",
    ckData: "",
    attachments: [],
    errors: {
      subject: "",
      ckData: "",
      seversity: "",
      ValidationRules: [
        {
          FieldName: "subject",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "ckData",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "seversity",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  const fnInputChange = (value, tag) => {
    setSupportInput({
      ...supportInput,
      [tag]: value,
    });
  };

  const handleCKEditor = (content, tag) => {
    setSupportInput({
      ...supportInput,
      [tag]: content,
    });
  };

  const HandleSupportFileChange = async (e) => {
    let allFiles = [];

    const files = e?.target?.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      allFiles.push(file);
    }

    setSupportInput({
      ...supportInput,
      attachments: [...supportInput.attachments, ...allFiles],
    });
  };

  const handleSaveSupport = (e) => {
    e.preventDefault();

    let obj = commonservices.fnCheckValidationOfObject(supportInput);
    setSupportInput({
      ...obj.obj,
    });
    if (obj.isValid) {
      let body = {
        title: supportInput.subject,
        detail: supportInput.ckData,
        tags: supportInput.tags,
        priority_term: supportInput.seversity,
        caseAttachments: supportInput.attachments,
        casetype_term: props?.case_Type,
        usertype_term: props?.user_Type,
        associationid: props?.ass_Id,
        associationtype_term: props?.ass_Type,
      };
      setLoadingSubmit(true);
      dispatch(CaseSave(body))?.then((response) => {
        if (response?.payload?.isValidate) {
          //  response?.payload?.data?.data
          setLoadingSubmit(false);
          props.onHide();
        }
        if (!response?.payload?.isValidate) {
          setLoadingSubmit(false);
        }
      });
    }
  };

  async function getProjectTermList() {
    setLoading(true);
    dispatch(ProjectTermGetList({}))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data?.length > 0) {
          setLoading(false);
          let priorityStatus = response?.payload?.data?.data.filter(
            (f) => f.category === "Priority Term"
          );
          setProjectTermList({
            Priority: priorityStatus,
          });
          setSupportInput({
            ...supportInput,
            seversity: priorityStatus[0].term,
          });
        }
      }
      if (!response?.payload?.isValidate) {
        setLoading(false);
      }
    });
  }

  useEffect(() => {
    getProjectTermList();
  }, []);

  return (
    <>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
        className="normal-modal log-modal model-dimension invoice-model "
        backdrop="static"

      >
        <Modal.Header closeButton>
          <Modal.Title className="invoice-model-title" id="contained-modal-title-vcenter ">
            <Row>
              <Col md={7}>
            <h4>Invoice</h4>
            </Col>
            <Col md={5}>
            <div className="invoice-model-title-inner">
              <p className="mb-2">Invoice Number<span>#INV-53303556</span></p>
              <p>Invoice Date<span>September 10, 2024</span></p>
            </div>
            </Col>
            </Row>
          </Modal.Title>
          
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white" }}>
         
<div>
            <div className="main-invoice-section">
              <h2>Quantumdatalytica  Information</h2>
              <Row>
                <Col md={6}>
                <div className="invoice-info mb-2">
                  <p>QuantumDataLyitica</p>
                </div>
                </Col>
                <Col md={6}>
                <div className="invoice-info mb-2">
                  <p>(219) 555-0054</p>
                </div>
                </Col>
                <Col md={6}>
                <div className="invoice-info">
                  <p>Suite 400, Greenway Business Center 7890 Innovation, TX 73301 US</p>
                </div>
                </Col>
                <Col md={6}>
                <div className="invoice-info">
                  <p>TX-987654321</p>
                </div>
                </Col>
                
              </Row>
            </div>
            <div className="main-invoice-section">
              <h2>Billing Information</h2>
              <Row>
                <Col md={6}>
                <div className="invoice-info mb-2">
                  <p>QuantumDataLyitica Development Team</p>
                </div>
                </Col>
                <Col md={6}>
                <div className="invoice-info mb-2">
                  <p>support@quantumdatalytica.com</p>
                </div>
                </Col>
                <Col md={6}>
                <div className="invoice-info">
                  <p>(219) 555-0114</p>
                </div>
                </Col>
                
              </Row>
            </div>
            <div className="main-invoice-section mb-0">
              <h2 className="mb-2">Product</h2>
              
              <Table responsive>
              <thead>
          <tr>
            <th>Description</th>
            <th className="text-center">Quantity</th>
            <th className="text-center">Workflow</th>
            <th className="text-end">Amount</th>
          </tr>
        </thead>
        <tbody>
                  <tr>
                    <td >
  <div className="profile-purchases-inner d-flex gap-2 align-items-center">
                      <div className="profile-purchases-pic">
                        <img
                          src={My_machine}
                          width={"25px"}
                          height={"25px"}
                          alt="My_machine"
                        />
                      </div>
                      <div>
                        <div className="purchase-listing-show d-flex">
                          <h4 >
                          Annual Summary
                          </h4>
                          
                        </div>

                        <div
                          className="grey-btn purchase-content"
                          style={{ padding: "5px 5px" }}
                        >
                         <p>Python</p>
                        </div>
                      </div>
                   
                    </div>
                    </td>
                    <td className="text-center">
                      <div className="pt-3">
                      1
                      </div>
                      </td>
                    <td className="text-center center-align"> <div className="pt-3">300</div></td>
                    <td className="text-end">
                     <div className="pt-3">$200.00</div> 
                    </td>
                  </tr>
                  <tr>
                    <td >
  <div className="profile-purchases-inner d-flex gap-2 align-items-center">
                      <div className="profile-purchases-pic">
                        <img
                          src={My_machine}
                          width={"25px"}
                          height={"25px"}
                          alt="My_machine"
                        />
                      </div>
                      <div>
                        <div className="purchase-listing-show d-flex">
                          <h4 >
                          Annual Summary
                          </h4>
                          
                        </div>

                        <div
                          className="grey-btn purchase-content"
                          style={{ padding: "5px 5px" }}
                        >
                         <p>Python</p>
                        </div>
                      </div>
                   
                    </div>
                    </td>
                    <td className="text-center">
                      <div className="pt-3">
                      1
                      </div>
                      </td>
                    <td className="text-center center-align"> <div className="pt-3">300</div></td>
                    <td className="text-end">
                     <div className="pt-3">$200.00</div> 
                    </td>
                  </tr>
                  
                  
                </tbody>
              </Table>
            </div>
            <div className="invoice-totle">
<div className="invoice-totle-inner">
  <p className="mb-2">Sub Total<span>$200.00</span></p>
  <p className="mb-2">TAX(12%)<span>$24.00</span></p>
  <p className="totledata-calc">Total<span>$224.00</span></p>
</div>
            </div>

            </div>
        </Modal.Body>
        <Modal.Footer>
          
            <div className="d-flex gap-2">
              <button
                disabled={loadingSubmit}
                className="grey-btn invoice-grey"
                onClick={props.onHide}
              >
                Cancel
              </button>
              <button
                disabled={loadingSubmit}
                className={"blue-btn"}
                // onClick={handleSaveSupport}
              >
                <div className="d-flex gap-2 downloadicon-invoice">
                <img src={download} alt="download" />
                Invoice
                </div>
              </button>
            </div>
          
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default InvoiceModel;
